import { forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { CustomResponse } from '../services/caseManagement.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MessageService } from '../core/message-service/message.service';
import { SignupService } from '../services/signup.service';
import { SignUpDataTransferService } from '../services/signup-datatransfer.service';
import { StateTypeDetails } from '../models/state-type-details';
import { CommonService } from '../services/common.service';
import { patterns } from '../../assets/patterns';
import { CompleteSignUpService } from '../services/complete-sign-up.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  private rootURL: string = environment.baseUrl;
  registrationDetails: UntypedFormGroup;
  submitted: boolean = false;
  preSignUpSTDetails: StateTypeDetails[];
  public loading = false;
  failedSignUp: boolean = false;
  signUpResponse: CustomResponse;
  customResponse: CustomResponse;
  InvitedEmail: any;
  customerUserInformationId: number;
  selectedStateTypeID: number;
  errorMsg: string;
  mobileNumber: any;
  mobileError: any;
  officeError: any;
  errorMsgEmail: String;
  errorMsgPhone: String;
  errorId: number;
  usersGeoCode: any;
  password: any;
  arrYesNo = ['No', 'Yes'];
  isFormSubmitted = false;
  customerEmailValidationText: string;
  companyDetails: any;
  companySummaryInformation: any;
  userInformationResponse: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private http: HttpClient,
    private signupService: SignupService,
    private signUpDataTransferService: SignUpDataTransferService,
    private messageService: MessageService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private completeSignUpService: CompleteSignUpService,

  ) {
    this.loading = true;
    this.route.params.subscribe(params => {
      this.InvitedEmail = params.email;
    });
    this.completeSignUpService.pageLoader.subscribe((res: boolean) => {
      this.loading = res;
    });
  }

  ngOnInit() {
    this.commonService.checkLoggedInUser();
    this.signupService.getStateType().subscribe((data: any) => {
      this.loading = false;
      this.preSignUpSTDetails = data;
    }, (err: HttpErrorResponse) => {
      this.loading = false;
      console.error('SignupComponent_ngOnInit', err);
    });

    this.registrationDetails = this.formBuilder.group({
      companyName: ['', [Validators.required, Validators.pattern(patterns.longNamePattern)]],
      firstname: ['', [Validators.required, Validators.pattern(patterns.textNumber)]],
      lastname: ['', [Validators.required, Validators.pattern(patterns.namePattern)]],
      middlename: [''],
      officePhone: ['', Validators.pattern(patterns.mobNumPattern)],
      email: ['', Validators.compose([Validators.required, Validators.pattern(patterns.emailPattern)])],
      password: ['', [Validators.required, Validators.pattern(patterns.passwordPattern)]],
      confpassword: ['', Validators.required],
      address: ['', [Validators.required, Validators.pattern(patterns.addressPattern)]],
      city: ['', [Validators.required, Validators.pattern(patterns.cityPattern)]],
      stateTypeId: ['', Validators.required],
      zip: ['', [Validators.required, Validators.pattern(patterns.numberPattern)]],
      phone: ['', Validators.compose([Validators.pattern(patterns.mobNumPattern)])],
      extension: [''],
      billingEmail: ['', Validators.compose([Validators.required, Validators.pattern(patterns.emailPattern)])],
      timeZoneTypeId: [''],
      subScriptionType: ['standard'],
      isInvitedCustomer: [0],
    });

    if (this.InvitedEmail) {
      this.loading = true;
      const invitedCustomerReq = this.signupService.getInvitedCustomer(this.InvitedEmail);
      const updateInviteAcceptedDateReq = this.signupService.updateInviteAcceptedDate(this.InvitedEmail);
      forkJoin([invitedCustomerReq, updateInviteAcceptedDateReq]).subscribe((res: any) => {
        this.loading = false;
        const data = res[0];
        if (data.length) {
          this.registrationDetails.controls.companyName.setValue(data[0].CPvc255CompanyName);
          this.registrationDetails.controls.firstname.setValue(data[0].CPvc255FirstName);
          this.registrationDetails.controls.lastname.setValue(data[0].CPvc255LastName);
          this.registrationDetails.controls.phone.setValue(data[0].CPvc255MobileNumber);
          this.registrationDetails.controls.email.setValue(data[0].CPvc255Email);
          this.registrationDetails.controls.subScriptionType.setValue(data[0].CPvc255Classification);
          this.registrationDetails.controls.isInvitedCustomer.setValue(1);
        } else {
          this.router.navigate(['/invitationExpire']);
        }
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        console.error('SignupComponent_ngOnInit', err);
      });
    }
  }

  register(): void {
    this.failedSignUp = false;
    this.isFormSubmitted = true;
    this.loading = true;
    this.submitted = true;
    if (this.registrationDetails.invalid) {
      this.registrationDetails.markAllAsTouched();
      this.isFormSubmitted = false;
      this.loading = false;
      return;
    }

    if (this.registrationDetails.valid) {
      this.signupService.registerUser(this.registrationDetails.value).subscribe((response) => {
        this.signUpDataTransferService.setEmail(this.registrationDetails.controls.email.value);
        if (response.customerUserInformationID) {
          this.customerUserInformationId = response.customerUserInformationID;
          this.customerEmailValidationText = response.customerEmailValidationText;
          this.createCompanyProfile();
        } else if (response.id == 100) {
          this.loading = false;
          this.failedSignUp = true;
          this.isFormSubmitted = false;
          this.errorMsg = 'User already registered with given details!';
          alert('User already registered with given details');
        } else if (response.id == 101) {
          this.loading = false;
          this.failedSignUp = true;
          this.isFormSubmitted = false;
          this.errorId = 101;
          this.errorMsgEmail = 'Email Id already exist!';
          // this.errorMsgPhone = 'Mobile Number already exist!';
        } else if (response.id == 102) {
          this.loading = false;
          this.failedSignUp = true;
          this.isFormSubmitted = false;
          this.errorId = 102;
          this.errorMsgEmail = 'Email Id already exist!';
        } else if (response.id == 103) {
          this.loading = false;
          this.failedSignUp = true;
          this.isFormSubmitted = false;
          this.errorId = 103;
          this.errorMsgPhone = 'Mobile Number already exist!';
        } else if (response.id == 104) {
          this.loading = false;
          this.failedSignUp = true;
          this.isFormSubmitted = false;
          this.errorId = 104;
          this.errorMsgPhone = 'Please check your mobile number!';
        } else {
          this.loading = false;
          this.failedSignUp = true;
          this.isFormSubmitted = false;
          this.errorMsg = 'Failed to register. Please try again.'
          this.messageService.showWarning('Error creting user please try again');
        }
      }, (error: HttpErrorResponse) => {
        this.loading = false;
        this.errorMsg = 'Failed to register. Please try again.'
        this.failedSignUp = true;
        this.isFormSubmitted = false;
        console.error('SignupComponent_register', error);
        return;
      });
    }
  }

  changeRegiatrationFailedStatus() {
    this.failedSignUp = false;
  }

  createCompanyProfile() {
    const data = {
      'address': this.registrationDetails.controls.address.value,
      'city': this.registrationDetails.controls.city.value,
      'companyName': this.registrationDetails.controls.companyName.value,
      'driverAuthorizedToCall': true,
      'totalPowerUnits': 2,
      'totalSpecialEquipments': 2,
      'totalTrailingUnits': 2,
      'phoneNumber': this.registrationDetails.controls.officePhone.value,
      'poRequired': true,
      'state': this.registrationDetails.controls.stateTypeId.value,
      'customerUserInformationID': this.customerUserInformationId,
    }
    this.loading = true;
    this.http.post(this.rootURL + 'api/questionare/customerParentInformation', data).subscribe((response: any) => {
      this.loading = false;
      this.customResponse = response;
      if (this.customResponse.body > 0) {
        localStorage.setItem('localPassword', this.registrationDetails.controls.password.value);
        if (this.registrationDetails.controls.isInvitedCustomer.value) {
          this.signupService.verifyEmail(this.customerEmailValidationText).subscribe((result: any) => {
            if (result) {
              this.signupService.setCompanyDetails(result);
              this.signupService.setIsAgreementAccepted(true);
              // this.router.navigate(['/termsAndConditions']);
              this.completeSignUpService.setPageLoader();
              this.completeSignUpService.completeSignUp();
            }
          });
        } else {
          this.router.navigate(['/signup-success']);
        }
      }
    }, (error) => {
      this.loading = false;
      console.error('SignupComponent_createCompanyProfile', error);
    });
  }

  zipCodeEntered() {
    if (this.registrationDetails.controls.zip.value.toString().length >= 4) {
      this.http.get('https://ziptasticapi.com/' + this.registrationDetails.controls.zip.value).subscribe((response: any) => {
        if (response.city) {
          this.registrationDetails.controls.city.setValue(response.city);
        }
        if (response.state) {
          this.registrationDetails.controls.stateTypeId.setValue(response.state);
        }

        let fullAddress = this.registrationDetails.controls.address.value + ' ' + this.registrationDetails.controls.city.value + ' ' + this.registrationDetails.controls.stateTypeId.value;
        this.signupService.getLatLong(fullAddress).subscribe((response: any) => {
          this.usersGeoCode = response.results[0].geometry.location;
          this.signupService.getUsersTimezone(this.usersGeoCode).subscribe((res: any) => {
            this.registrationDetails.controls.timeZoneTypeId.setValue(res.timeZoneId);
          });
        });
      });
    }
  }

  getlength($event, controll) {
    this.mobileError = 0;
    this.officeError = 0;
    let number = $event.target.value;
    number = number.toString();
    this.mobileNumber = number.replace(/[-()]/g, '');
    let moblength = this.mobileNumber.length;
    if (moblength > 10) {
      if (controll == 1) {
        this.mobileError = 1;
      } else {
        this.officeError = 1;
      }
    }
  }
}
